import React from 'react';
import { PrivyProvider } from '@privy-io/react-auth';
import { defineChain } from 'viem';

interface AppPrivyProviderProps {
  children: React.ReactNode;
}

// 1. Definisikan Custom Chain untuk Somnia Testnet
const somniaTestnet = defineChain({
  id: 50312,
  name: 'Somnia Testnet',
  network: 'somnia-testnet',
  nativeCurrency: { name: 'STT', symbol: 'STT', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://dream-rpc.somnia.network'] },
    public: { http: ['https://dream-rpc.somnia.network'] },
  },
  blockExplorers: {
    default: { name: 'Shannon Explorer', url: 'https://shannon-explorer.somnia.network' },
  },
});

export function AppPrivyProvider({ children }: AppPrivyProviderProps) {
  const privyAppId = import.meta.env.VITE_PRIVY_APP_ID;

  if (!privyAppId) {
    throw new Error('VITE_PRIVY_APP_ID is required. Please set it in your .env file.');
  }

  return (
    <PrivyProvider
      appId={privyAppId}
      config={{
        // Use Somnia as the default network.
        supportedChains: [somniaTestnet],
        defaultChain: somniaTestnet,

        loginMethodsAndOrder: {
          primary: ['email', 'metamask', 'detected_ethereum_wallets', 'wallet_connect'],
        },
        appearance: {
          theme: 'dark',
          accentColor: '#2596be',
          landingHeader: 'Sign in with Privy',
          loginMessage: 'Connect your EOA wallet to play Kingsomni.',
          showWalletLoginFirst: true,
          walletChainType: 'ethereum-only',
          walletList: [
            'metamask',
            'detected_ethereum_wallets',
            'wallet_connect',
            'coinbase_wallet',
            'rabby_wallet',
            'haha_wallet',
          ],
          logo: '/favicon.png',
        },
        embeddedWallets: {
          createOnLogin: 'off',
          ethereum: { createOnLogin: 'off' },
          solana: { createOnLogin: 'off' },
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
}
